import React from 'react';
import { createIcon } from '../../../utils';

const IconSlack = createIcon({
  viewBox: '0 0 28 28',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="29"
        height="28"
        viewBox="0 0 29 28"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7296 14.5645C10.5155 14.5645 9.52361 15.5563 9.52361 16.7705V22.2941C9.52361 23.5083 10.5155 24.5001 11.7296 24.5001C12.9438 24.5001 13.9357 23.5083 13.9357 22.2941V16.7705C13.9357 15.5563 12.9438 14.5645 11.7296 14.5645ZM6.20603 18.9765C7.4202 18.9765 8.41205 17.9847 8.41205 16.7705V14.5645H6.20603C4.99186 14.5645 4 15.5563 4 16.7705C4 17.9847 4.99186 18.9765 6.20603 18.9765Z"
          fill="#E01E5A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.52361 5.70603C9.52361 6.9202 10.5155 7.91205 11.7296 7.91205H13.9357V5.70603C13.9357 4.49186 12.9438 3.5 11.7296 3.5C10.5155 3.5 9.52361 4.49186 9.52361 5.70603ZM13.9357 11.2297C13.9357 10.0155 12.9438 9.02363 11.7296 9.02363H6.20603C4.99186 9.02363 4 10.0155 4 11.2297C4 12.4438 4.99186 13.4357 6.20603 13.4357H11.7296C12.9438 13.4357 13.9357 12.4438 13.9357 11.2297Z"
          fill="#36C5F0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.2705 13.4357C18.4846 13.4357 19.4765 12.4438 19.4765 11.2296V5.70603C19.4765 4.49186 18.4846 3.5 17.2705 3.5C16.0563 3.5 15.0645 4.49186 15.0645 5.70603V11.2296C15.0645 12.4438 16.0563 13.4357 17.2705 13.4357ZM22.7941 9.02363C21.5799 9.02363 20.5881 10.0155 20.5881 11.2297V13.4357H22.7941C24.0083 13.4357 25.0001 12.4438 25.0001 11.2297C25.0001 10.0155 24.0083 9.02363 22.7941 9.02363Z"
          fill="#2EB67D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.0645 16.7705C15.0645 17.9846 16.0563 18.9765 17.2705 18.9765H22.7941C24.0083 18.9765 25.0001 17.9846 25.0001 16.7705C25.0001 15.5563 24.0083 14.5645 22.7941 14.5645H17.2705C16.0563 14.5645 15.0645 15.5563 15.0645 16.7705ZM19.4765 22.2941C19.4765 21.0799 18.4846 20.0881 17.2705 20.0881H15.0645V22.2941C15.0645 23.5083 16.0563 24.5001 17.2705 24.5001C18.4846 24.5001 19.4765 23.5083 19.4765 22.2941Z"
          fill="#ECB22E"
        />
      </svg>
    </>
  ),
});

export default IconSlack;
